module.exports = __webpack_public_path__ + "img/cctv_news@2x.e7c4d551.png";